// extracted by mini-css-extract-plugin
module.exports = {"section":"FAQGroup_section__d_16q","layout":"FAQGroup_layout__U1Kju","heading":"FAQGroup_heading__nyc_6","questions":"FAQGroup_questions__rQ05_","answer":"FAQGroup_answer__5lylh"};